import { Component, ElementRef, Renderer2, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ProductService } from '../../services/productservice';
import { PageStateService } from '../../services/pageStateService';

@Component({
  selector: 'app-faq',
  templateUrl: './faq.component.html',
  styleUrls: ['./faq.component.scss'],
})
export class FaqComponent implements OnInit {
  faqs: { question: string; answer: string }[] = [];
  constructor(
    private http: HttpClient,
    private pageStateService: PageStateService,
    public productService: ProductService,
    private renderer: Renderer2
  ) {}

  ngOnInit(): void {
    this.pageStateService.hideSubscribePanel = true;
    this.getFAQs();
  }

  getFAQs() {
    this.productService.getFaqDetails().subscribe((response) => {
      if (response.results && response.results.length > 0) {
        const result = response.results[0].field_faq;
        const parser = new DOMParser();
        const doc = parser.parseFromString(result, 'text/html');
        const questions = doc.querySelectorAll('.faqfield-question');
        const answers = doc.querySelectorAll('.faqfield-answer');

        if (questions.length === answers.length) {
          for (let i = 0; i < questions.length; i++) {
            const question = questions[i].textContent.trim();
            const answer = answers[i].querySelector('p').textContent.trim();
            this.faqs.push({ question, answer });
          }
        }
      }
    });
  }
}
